import { MultiplayerRoomCapability } from '@doxyme/extensions-bridge';
import { useAppSelector } from '../../useReduxToolkit';
import { getMembers } from '../../../features/realtime/realtime.selectors';
import { useExtensionsMultiplayer } from './useExtensionsMultiplayer';

export function useExtensionsMultiplayerRoom(): void {
  const members = useAppSelector(getMembers);

  useExtensionsMultiplayer(MultiplayerRoomCapability, members);
}
